import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Calculator, Shield, Globe, Search } from 'lucide-react';
const categories = [{
  id: 'registration',
  name: 'Реєстрація та старт',
  icon: <FileText size={24} strokeWidth={1.5} data-id="element-137" />,
  description: 'Для тих, хто тільки відкриває бізнес',
  services: ['Відкриття ТОВ, ФОП, ФГ, БФ, БО, ГО', 'Вибір системи оподаткування та КВЕДів', 'Налаштування ПРРО / РРО', 'Підключення програм обліку (BAS, MEDOC, 1С, ODOO та ін.)', 'Підключення до електронного кабінету']
}, {
  id: 'accounting',
  name: 'Бухгалтерський супровід',
  icon: <Calculator size={24} strokeWidth={1.5} data-id="element-138" />,
  description: 'Регулярне ведення обліку для діючого бізнесу',
  services: ['Ведення ТОВ на загальній/спрощеній системі (з ПДВ / без)', 'Облік ПДВ, реєстрація податкових накладних', 'Розрахунок зарплати та звітність', 'Моніторинг електронного кабінету платника', 'Облік доходів та контроль сплати податків', 'Виробничий облік, управлінський облік', 'Робота з Payoneer, Wise, Paysera, Finmap, ВЧАСНО']
}, {
  id: 'vat',
  name: 'ПДВ та розблокування',
  icon: <Shield size={24} strokeWidth={1.5} data-id="element-139" />,
  description: 'Спеціалізація, яку мало хто вміє',
  services: ['Облік та реєстрація податкових накладних', 'Розблокування заблокованих накладних', 'Виключення з реєстру ризикових платників', 'Оскарження відмов у реєстрації ПН', 'Формування таблиці даних платника ПДВ', 'Аналіз ризиковості платника']
}, {
  id: 'specialized',
  name: 'Спеціалізовані напрямки',
  icon: <Globe size={24} strokeWidth={1.5} data-id="element-140" />,
  description: 'Складні проєкти та нішеві задачі',
  services: ['ЗЕД: експорт / імпорт', 'ІТ-сфера та резиденти Дія Сіті', 'КІК (контрольовані іноземні компанії)', 'ТЦУ (трансфертне ціноутворення)', 'Ліцензування, АКЦИЗ', 'Благодійні фонди та громадські організації']
}, {
  id: 'audit',
  name: 'Аудит, відновлення, консультації',
  icon: <Search size={24} strokeWidth={1.5} data-id="element-141" />,
  description: 'Разові послуги та антикризова допомога',
  services: ['Аудит бухгалтерського обліку', 'Відновлення обліку', 'Експрес-перевірка стану обліку з рекомендаціями', 'Перевірка правильності розрахунку податків', 'Оптимізація оподаткування', 'Юридичний супровід', 'Разові консультації (онлайн / офіс)']
}];
export function Services() {
  return <section id="services" className="py-24 bg-surface" data-id="element-142">
      <div className="max-w-7xl mx-auto px-6" data-id="element-143">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-144">
          <h2 className="text-3xl md:text-4xl font-semibold mb-4" data-id="element-145">
            Мої послуги
          </h2>
          <p className="text-secondary text-lg" data-id="element-146">
            Повний спектр бухгалтерських послуг для бізнесу будь-якого масштабу
          </p>
        </div>

        <div className="space-y-8" data-id="element-147">
          {categories.map((category, categoryIndex) => <motion.div key={category.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: categoryIndex * 0.1
        }} className="bg-background rounded-3xl border border-border p-8 md:p-10" data-id="element-148">
              <div className="flex items-start gap-4 mb-8" data-id="element-149">
                <div className="w-14 h-14 bg-surface rounded-2xl flex items-center justify-center text-primary border border-border shrink-0" data-id="element-150">
                  {category.icon}
                </div>
                <div className="flex-1" data-id="element-151">
                  <h3 className="text-2xl font-semibold mb-2" data-id="element-152">
                    {category.name}
                  </h3>
                  <p className="text-secondary text-sm" data-id="element-153">
                    {category.description}
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-154">
                {category.services.map((service, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: categoryIndex * 0.1 + index * 0.03
            }} className="flex items-start gap-3 p-4 rounded-xl bg-surface border border-border hover:border-primary/30 transition-colors" data-id="element-155">
                    <div className="w-1.5 h-1.5 rounded-full bg-primary mt-2 shrink-0" data-id="element-156" />
                    <p className="text-primary text-sm leading-relaxed" data-id="element-157">
                      {service}
                    </p>
                  </motion.div>)}
              </div>
            </motion.div>)}
        </div>

        <div className="text-center mt-12" data-id="element-158">
          <a href="#contact" className="inline-flex items-center justify-center px-8 py-4 bg-primary text-background rounded-full font-medium hover:opacity-90 transition-opacity shadow-lg" data-id="element-159">
            Замовити консультацію
          </a>
        </div>
      </div>
    </section>;
}